import { point, lineString, multiLineString } from '@turf/helpers';
import center from '@turf/center';
import { makeEmptyGeojson } from 'modules/geojson';

import { Coordinate, InputRoute, Route, RouteWaypoint } from './types';

const GATE_ENDPOINTS = 2;

const isGate = (
  coordinates: Coordinate | Coordinate[],
): coordinates is Coordinate[] => Array.isArray(coordinates[0]);

const gateMidpoint = (coordinates: Coordinate[]): Coordinate =>
  center(lineString(coordinates)).geometry.coordinates as Coordinate;

// Mirrors the route-creation rendering: gate endpoints are isGate points, the
// gate bar is its own line, and the route line passes through each gate's centre.
export const createRouteGeojsonFromRouteData = (
  data: Route,
): GeoJSON.FeatureCollection<GeoJSON.Geometry, GeoJSON.GeoJsonProperties> => {
  const pointFeatures: GeoJSON.Feature[] = [];
  const gateLines: GeoJSON.Feature[] = [];
  const pathCoordinates: Coordinate[] = [];
  let index = 0;

  data.route.forEach(({ coordinates }) => {
    if (isGate(coordinates)) {
      coordinates.forEach((endpoint) => {
        pointFeatures.push(point(endpoint, { index, isGate: true }));
        index += 1;
      });
      if (coordinates.length === GATE_ENDPOINTS) {
        gateLines.push(lineString(coordinates, { isGate: true }));
        pathCoordinates.push(gateMidpoint(coordinates));
      }
    } else {
      pointFeatures.push(point(coordinates, { index, isGate: false }));
      index += 1;
      pathCoordinates.push(coordinates);
    }
  });

  const routeLine =
    pathCoordinates.length > 1 ? [multiLineString([pathCoordinates])] : [];

  const geojson = makeEmptyGeojson();
  geojson.features = [...pointFeatures, ...routeLine, ...gateLines];
  return geojson;
};

export const routeToWaypointCoordinates = (
  route: InputRoute,
): RouteWaypoint['coordinates'][] =>
  route.map(({ coordinates }) => coordinates);
